import revealGlsl from '../../shaders/partials/revealDrop.glsl'

/**
 * Açılış düşüşünü (shaders/partials/revealDrop.glsl) Three'nin hazır malzemelerine (MeshBasicMaterial:
 * düz renkler, tabela yazıları, video ekranları, lambalar) ekler; matcap nesneleriyle birlikte düşerler,
 * havada asılı kalmazlar. _uniform: paylaşılan { value } (World reveal tick günceller).
 */
export default function applyRevealDrop(_material, _uniform)
{
    if(_material.userData.revealDrop)
    {
        return
    }
    _material.userData.revealDrop = true
    _material.defaultAttributeValues = { ...(_material.defaultAttributeValues || {}), aReveal: [0, 0, 0, 1] }
    _material.onBeforeCompile = (_shader) =>
    {
        _shader.uniforms.uRevealProgress = _uniform
        _shader.vertexShader = `${revealGlsl}\n${_shader.vertexShader.replace('#include <project_vertex>', `
            vec4 revealWorld = vec4(transformed, 1.0);
            #ifdef USE_INSTANCING
                revealWorld = instanceMatrix * revealWorld;
            #endif
            revealWorld = modelMatrix * revealWorld;
            revealWorld.z += revealOffset(aReveal, modelMatrix);
            vec4 mvPosition = viewMatrix * revealWorld;
            gl_Position = projectionMatrix * mvPosition;
        `)}`
    }
    _material.customProgramCacheKey = () => 'llpRevealDrop'
    _material.needsUpdate = true
}

/**
 * Nesne yere indi mi (0 → 1): revealDrop.glsl ile aynı zamanlama — gölgeler nesne yere değince belirir.
 * start = min(uzaklık / 140, 0.7), düşüş penceresi 0.3, ilk temas pencerenin %72'sinde.
 */
export function revealLanded(_x, _y, _progress)
{
    const start = Math.min(Math.hypot(_x, _y) / 140, 0.7)
    const impact = start + 0.3 * 0.72
    return Math.min(Math.max((_progress - impact) / 0.08, 0), 1)
}
